<template>
  <div class="fragment">

<!--    <SearchEngine/>-->


    <div class="content-top-line content-top-line--with-bottom-line">
      <div class="content-tabs content-tabs--separator">
<!--        <div class="content-tabs__item " v-bind:class="{active: tab === 1}" @click="changeTab(1)">-->
<!--          <div class="content-tabs__ico">-->
<!--           -->
<!--          </div>-->
<!--        </div>-->
      </div>

      <div class="content-top-line-wrap">
        <ToggleFilterButton :count="countFilterParams" @toggleFilter="$emit('toggleFilter')" :showFilter="showFilter" />
      </div>
    </div>

    <div class="light-bg-block">
      <div class="btn-right-block">
          <MainButton class="btn-fit-content ml-3"
                    :value="'Add Keyword'"
                    :ico="'ico'"
                    @click.native="changeShippingInsurancesPopup(true)"
        >
          <template slot="ico">
            <PlusIconSVG class="btn-icon-plus"/>
          </template>
        </MainButton>
      </div>
    </div>

    <ShippingInsurancesPopup
            v-if="isModalShippingInsurancesPopup"
            :type="'create'"
            @reload="$emit('reload')"
            @close="changeShippingInsurancesPopup(false)"
    />


  </div>
</template>



<script>
  import ToggleFilterButton from "../../../../../../UI/buttons/ToggleFilterButton/ToggleFilterButton";
  import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
  import PlusIconSVG from '../../../../../../../../public/img/UI-group/plus-icon.svg?inline'
  // import SearchEngine from "../../../../../../coreComponents/SearchEngine/SearchEngine";
  import ShippingInsurancesPopup from "../../../../popups/ShippingInsurancesPopup/ShippingInsurancesPopup";
  // import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";


  export default {
    name: "ShippingInsurancesHead",
    components: {
      ShippingInsurancesPopup,
      ToggleFilterButton,
      MainButton,
      PlusIconSVG,
      // DefaultCheckbox,
      // SearchEngine,
    },

    props: {
      showFilter: Boolean,
      countFilterParams: Number,
    },

    data(){
      return{

        isModalShippingInsurancesPopup: false,
      }
    },

    methods: {

      changeShippingInsurancesPopup(val, id = false) {
        if(id){
          this.orderId = id
        }
        this.isModalShippingInsurancesPopup = val

        if(!val){
          this.orderId = -1
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../../../../scss/mixins/mixins";


</style>

